import apiClient from '../axiosInstance';
import { API_BASE_ADDRESS } from '../api';

const reserveHistoryService = (action: any) => {
  return {
    getReserveHistory: () =>
      apiClient.get(`${API_BASE_ADDRESS}/mypage/yoyaku/reserve-history`, {
        params: {
          member_id: action.memberId,
          request_year_month: action.requestYearMonth,
        },
      }),
    putCancelReserve: () =>
      apiClient.put(`${API_BASE_ADDRESS}/mypage/yoyaku/cancel-reserve`, {
        contents_id: action.contentsId,
        schedule_id: action.scheduleId,
      }),
    putRemoveWaitCancel: () =>
      apiClient.put(`${API_BASE_ADDRESS}/mypage/yoyaku/remove-wait-cancel`, {
        contents_time_cancel_wait_id: action.contentsTimeCancelWaitId,
      }),
  };
};

export default reserveHistoryService;
